export enum SigningPackageProvider {
  SIGNHERE = 'SIGNHERE',
}
